import styled from 'styled-components';

import { VinCarLogoTypeColor } from './assets';

export const Root = styled.div`
  height: 100%;
`;

export const LogoContainer = styled.div`
  bottom: 0;
  display: flex;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
`;

export const Logo = styled(VinCarLogoTypeColor)`
  margin: auto;
`;
